module.exports = __webpack_public_path__ + "media/assets/images/logos/binarysystem_black_logo-87f42146e2e2d79ba6e9d57c60f9b171.png";